import XCore from '../../../compsNa/XCore';
import css from './index.module.scss';
export default function TheComp() {
    return (
        <div className={css.TheComp}>
            <XCore />
        </div>
    );
}
